import { InsuredDeclaredValue } from './view';

export default InsuredDeclaredValue;
